import React from 'react'

type Props = { className?: string }

const Svg: React.FC<React.PropsWithChildren<Props>> = ({ className, children }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
  >
    {children}
  </svg>
)

export const SearchSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </Svg>
)

export const GridSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </Svg>
)

export const ListSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <circle cx="4" cy="6" r="1" fill="currentColor" />
    <circle cx="4" cy="12" r="1" fill="currentColor" />
    <circle cx="4" cy="18" r="1" fill="currentColor" />
  </Svg>
)

export const BuildingSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <line x1="9" y1="8" x2="9" y2="8.01" />
    <line x1="15" y1="8" x2="15" y2="8.01" />
    <line x1="9" y1="12" x2="9" y2="12.01" />
    <line x1="15" y1="12" x2="15" y2="12.01" />
    <line x1="9" y1="16" x2="9" y2="16.01" />
    <line x1="15" y1="16" x2="15" y2="16.01" />
  </Svg>
)

export const MapPinSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </Svg>
)

export const ImageSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <path d="M21 15l-5-5L5 21" />
  </Svg>
)

export const LockSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 018 0v4" />
  </Svg>
)

export const DownloadSvg: React.FC<Props> = ({ className }) => (
  <Svg className={className}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </Svg>
)
